import { UnsplashCredit } from '../common/UnsplashCredit';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CommunityPlanListItem } from '../../types';
import { Users, Star } from 'lucide-react';
import './PlanCard.css';

interface PlanCardProps {
  plan: CommunityPlanListItem;
}

const PlanCard: React.FC<PlanCardProps> = ({ plan }) => {
  const navigate = useNavigate();

  return (
    /* Framed so the credit can sit outside the press target (r775 finding 6).
       This was registered as a known-uncredited exception on the reasoning
       that nothing reachable renders it — but the component is barrel-
       exported, so the next caller would have made it reachable without
       touching any file the boundary scans. An exemption that depends on
       nobody using a public component is not an exemption. */
    <div className="community-plan-card-frame">
    <button
      className="community-plan-card"
      onClick={() => navigate(`/plans/p/${plan.slug}`)}
    >
      <div
        className={plan.hero_thumb_url
          ? 'community-plan-card-image'
          : 'community-plan-card-image community-plan-card-image--bare'}
        style={plan.hero_thumb_url
          ? { background: `url(${plan.hero_thumb_url}) center/cover` }
          : undefined}
      >
        {plan.is_staff_pick && (
          <span className="staff-pick-badge">
            <Star size={10} /> Staff Pick
          </span>
        )}
      </div>
      <div className="community-plan-card-body">
        <h4 className="community-plan-card-title">{plan.title}</h4>
        <p className="community-plan-card-dest">{plan.destination}</p>
        <div className="community-plan-card-meta">
          <span className="community-plan-card-days">{plan.duration_days} days</span>
          <span className="community-plan-card-dot">·</span>
          <span className="community-plan-card-group">{plan.group_type}</span>
          <span className="community-plan-card-dot">·</span>
          <span className="community-plan-card-used">
            <Users size={12} /> {plan.used_count.toLocaleString()}
          </span>
        </div>
        {plan.highlights.length > 0 && (
          <div className="community-plan-card-tags">
            {plan.highlights.slice(0, 3).map(h => (
              <span key={h} className="community-plan-card-tag">{h}</span>
            ))}
          </div>
        )}
      </div>
    </button>
      {plan.hero_thumb_url && plan.hero_attribution && (
        <UnsplashCredit
          photographer={plan.hero_attribution.photographer}
          profileLink={plan.hero_attribution.unsplash_link}
          className="card-photo-credit"
        />
      )}
    </div>
  );
};

export default PlanCard;
